import { render, staticRenderFns } from "./CommandCentre.vue?vue&type=template&id=68edcf29"
import script from "./CommandCentre.vue?vue&type=script&lang=ts"
export * from "./CommandCentre.vue?vue&type=script&lang=ts"
import style0 from "./CommandCentre.vue?vue&type=style&index=0&id=68edcf29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports